import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {getCalendarViews as getCalendarViewsApi} from '../../../services/calendarViews'

export async function getCalendarViews(dispatch, user_id) {
  try {
    dispatch({type: PENDING})
    let response = await getCalendarViewsApi(user_id)
    dispatch({type: SUCCESS, payload: response})
    return response
  } catch (e) {
    console.log(`Create Calendar View Failed: ${user_id}`)
    dispatch({type: FAILURE, payload: e})
    return Promise.reject(e)
  }
}
